module.exports = __webpack_public_path__ + "img/92.35fdc73c.png";